<template>
  <div>
    <v-toolbar app flat dark tabs color="primary">
      <v-btn icon @click="gotoOverview()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title>Ble</v-toolbar-title>
      <v-btn icon @click="scan()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-progress-linear :indeterminate="true" class="ma-0" v-if="scanning"></v-progress-linear>
      <v-list two-line >
        <template v-for="device in bleItems">
          <v-list-tile
            avatar
            ripple
            :key="device.id"
            class="e-connectz_list-tile"
            @click="gotoDevice(device)"
          >
            <v-list-tile-avatar>
              <i class="fa"></i>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ device.name }} - Rssi: {{ device.rssi }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ device.id }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon>
                <v-icon color="grey lighten-1">chevron_right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key="'divider-' + device.id"></v-divider>
        </template>

      </v-list>
    </v-content>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        scanning: false,
        bleItems: []
      }
    },
    methods: {
      scan() {
        if(typeof ble === 'undefined') return console.log('No available BLE');

        this.scanning = true;

        ble.startScan([], (device) => {
          if(!device.name || !device.id) return;
          if(device.advertising && device.advertising.kCBAdvDataLocalName) device.name = device.advertising.kCBAdvDataLocalName;
          this.bleItems = this.bleItems.filter((e) => e.id != device.id);
          this.bleItems = [device, ...this.bleItems];
        });

        setTimeout(ble.stopScan, 5000,
          () => this.scanning = false,
          () => this.scanning = false
        );
      },
      gotoOverview() {
        this.$router.go(-1);
      },
      gotoDevice(device) {
        if(!device.id) return;
        this.$router.push('/ble/' + device.id);
      },
    },
    mounted(){
      this.scan();
    }
  };
</script>

<style lang="stylus">
  .v-expansion-panel
    box-shadow: none
    border-top: solid 1px #ddd
    border-bottom: solid 1px #ddd
</style>
